export default "__VITE_ASSET__BF9oHwYH__"